// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-primary[data-v-c4c9519c]{margin-top:64px}`, "",{"version":3,"sources":["webpack://./resources/assets/vue/components/front/combination/ModalBodyProductItem.vue"],"names":[],"mappings":"AACA,8BACE,eAAA","sourcesContent":[".btn-primary{margin-top:64px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
